export const REQUEST_ACCESS_EXPERIMENT_FLAG_V3 =
  'apollo.web.request-access-when-blocked-v3';

export enum AUTO_INVITE_MESSAGES {
  SUCCESS = 'You successfully added a member to the board',
  ERR0R = 'Error Occured',
}

const SUCCESS_CONTENT_TITLE = 'Adding them now';
const SUCCESS__CONTENT_TEXT =
  "You'll soon be collaborating together on this board.";
const SUCCESS_BUTTON_TEXT = 'Go to board';
const DESCRIPTION = "We're adding:";

export const constants = {
  AUTO_INVITE_MESSAGES,
  REQUEST_ACCESS_EXPERIMENT_FLAG_V3,
  SUCCESS_CONTENT_TITLE,
  SUCCESS__CONTENT_TEXT,
  SUCCESS_BUTTON_TEXT,
  DESCRIPTION,
};
